module.exports = __webpack_public_path__ + "media/images/marquee-cd36ac9418c272693c89992896b4cdc1.jpg";